import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet4: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-4"><path d="M19.2493 6.5V4.75H3.94922C3.25886 4.75 2.69922 5.30964 2.69922 6C2.69922 6.69036 3.25886 7.25 3.94922 7.25H21.1992V19.25H4.69922C3.59465 19.25 2.69922 18.3546 2.69922 17.25V6.75M17.2493 13.25C17.2493 13.6642 16.9135 14 16.4993 14C16.0851 14 15.7493 13.6642 15.7493 13.25C15.7493 12.8358 16.0851 12.5 16.4993 12.5C16.9135 12.5 17.2493 12.8358 17.2493 13.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWallet4;
